// extracted by mini-css-extract-plugin
module.exports = {"title":"EmergencyForm_title__39m1x","field":"EmergencyForm_field__cGy9b","label":"EmergencyForm_label__2qZ79"};